import script from "./MobileBottomNav.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileBottomNav.vue?vue&type=script&setup=true&lang=js"

import "./MobileBottomNav.vue?vue&type=style&index=0&id=4519f1e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4519f1e8"]])

export default __exports__